export const PLAYER_SPEED = 170;
export const ENEMY_SHOT_SPEED = 188;
export const ENEMY_ATTACK_COOLDOWN_MS = 1050;
export const ENEMY_ALERT_DURATION_MS = 2400;
export const ENEMY_TURN_PAUSE_MS = 520;
export const ENEMY_INVESTIGATE_MS = 620;
export const ENEMY_ALERT_SPREAD_RANGE = 136;
export const AIM_DEAD_ZONE = 0.16;
